<template>
  <div>
    <navBox type="index" pagetype="index"/>
    <windowBox/>
    <div class="main">
      <div class="liveMain">
        <div style="display:flex; flex-direction:column; flex:1 1 auto; min-width:1010px">
          <div class="left-container">
            <div class="liveCon" style="flex:none">
              <livePlayBox :previewAnchorId='this.hotListData.length > 0 ? this.hotListData[0].id : 0' :bShowEnter='true' @playend='onPlayEnd' :bEnd="false"/>
            </div>
            <div class="liverListConHot" style="flex:1 1 auto">
              <ul v-if="this.hotListData.length > 0">
                <anchorListItem v-for="(item, index) in this.hotListData " :key='index' :itemData="item" @onClickHotListAnchor="onClickAnchor"></anchorListItem>
              </ul>
              <div v-else class='noAnchorFrameHot'>
                <div class='noAnchorIconHot' ></div>
                {{this.noAnchorString}}
              </div>
            </div>
          </div>
          <div class="liverList">
            <div class="mainListTitle">
              <div class="mainListTitleCon">
                <div class="mainListTitleIcon"></div>
                <p>最新主播</p>
              </div>
              <div class="mainListTitleMore" @click="onClickMoreNew">更多 ></div>
            </div>
            <div class="liverListCon">
              <ul v-if="this.anchorList.length > 0">
                <anchorListItem v-for="(item, index) in this.anchorList " :key='index' :itemData="item" @onClickHotListAnchor="onClickAnchor"></anchorListItem>
              </ul>
              <div v-else class='noAnchorFrameNew'>
                <div class='noAnchorIconNew' ></div>
                <span>{{this.noAnchorString}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 排行榜 -->
        <div style="display:flex; flex-direction:column; flex:none">
          <div class="rankTitleR">
            <div class="rankTitleCon">
              <div class="rankTitleIcon"></div>
              <p>排行榜</p>
            </div>
          </div>
          <div class="mainConR" style="flex:none">
            <div class="rankNav">
              <div :class="active==1?'active':''" @click="rankTab(1)">周消费榜</div>
              <div :class="active==2?'active':''" @click="rankTab(2)">主播周排行</div>
              <div :class="active==3?'active':''" @click="rankTab(3)">家族周排行</div>
            </div>
            <div class="rankMain">
              <ul v-show="active==1">
                <li class="rankItemR" :class="index==0?'no1':''" v-for="(el,index) in consumptionList" :key="index">
                  <div class="rankIndex">
                    <div :class="index==0?'rank-1':''" v-if="index==0"></div>
                    <div :class="index==1?'rank-2':''" v-if="index==1"></div>
                    <div :class="index==2?'rank-3':''" v-if="index==2"></div>
                    <div class="rankIndex" v-if="index>2">{{index+1}}</div>
                  </div>
                  <div class="rankPeoPic" >
                    <div :class="index==0?'rankPeoPicBoxBkg':''"></div>
                    <div class="rankPeoPicBox" >
                      <img :src="'https://img.fengbolive.com'+el.photo" width="100%" @error="defaultPic($event)">
                    </div>
                  </div>
                  <div class="rankPeoInfo">
                    <div class="rankPeoName">{{el.nick_nm}}</div>
                    <div class="rankPeoId">ID:{{el.user_id}}</div>
                  </div>
                  <div class="rankNum" v-if="index==0">{{isWhite?el.point:'独领风骚'}}</div>
                  <div class="rankNum" v-else-if="isWhite">{{el.point}}</div>
                  <div class="rankNum" v-else v-show="el.user_id==userInfo.user_id">差距:{{el.point_label}}</div>
                </li>
              </ul>
              <ul v-show="active==2">
                <li :class="index==0?'no1':''" v-for="(el,index) in mcRankList" :key="index">
                  <div class="rankIndex">
                    <div :class="index==0?'rank-1':''" v-if="index==0"></div>
                    <div :class="index==1?'rank-2':''" v-if="index==1"></div>
                    <div :class="index==2?'rank-3':''" v-if="index==2"></div>
                    <div class="rankIndex" v-if="index>2">{{index+1}}</div>
                  </div>
                  <div class="rankPeoPic">
                    <div class="rankPeoPicBox">
                      <img :src="'https://img.fengbolive.com'+el.photo" width="100%" @error="defaultPic($event)">
                    </div>
                  </div>
                  <div class="rankPeoInfo">
                    <div class="rankPeoName">{{el.nick_nm}}</div>
                    <div class="rankPeoId">ID：{{el.user_id}}</div>
                  </div>
                  <div class="rankNum" v-if="index==0">{{isWhite?el.point:'独领风骚'}}</div>
                  <div class="rankNum" v-else-if="isWhite">{{el.point}}</div>
                  <div class="rankNum" v-else v-show="el.user_id==userInfo.user_id">差距：{{el.point_label}}</div>
                </li>
              </ul>
              <ul v-show="active==3">
                <li :class="index==0?'no1':''" v-for="(el,index) in familyRankList" :key="index">
                  <div class="rankIndex">
                    <div :class="index==0?'rank-1':''" v-if="index==0"></div>
                    <div :class="index==1?'rank-2':''" v-if="index==1"></div>
                    <div :class="index==2?'rank-3':''" v-if="index==2"></div>
                    <div class="rankIndex" v-if="index>2">{{index+1}}</div>
                  </div>
                  <div class="rankPeoPic">
                    <div class="rankPeoPicBox">
                      <img :src="'https://img.fengbolive.com'+el.photo" width="100%" @error="defaultPic($event)">
                    </div>
                  </div>
                  <div class="rankPeoInfo">
                    {{el.family_name}}
                  </div>
                  <div class="rankNum" v-if="index==0">{{isWhite?el.point:'独领风骚'}}</div>
                  <div class="rankNum" v-else-if="isWhite">{{el.point}}</div>
                  <div class="rankNum" v-else v-show="el.user_id==userInfo.user_id">差距：{{el.point_label}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBox/>
  </div>
</template>
<script>
import navBox from "@/components/navbox";
import livePlayBox from "@/components/livePlayBox";
import footerBox from "@/components/footer";
import hotThreeAnchorItem from "@/components/anchorCard/hotThreeAnchorItem";
import anchorListItem from "@/components/anchorCard/anchorListItem";
import windowBox from "@/components/window";
import crypt from '@/js/utils/crypt.js';
import jsonpAdapter from 'axios-jsonp'
import '@/js/utils/string.js';
//var bus = new Vue();
export default {
  name: "index",
  components: { navBox,livePlayBox,footerBox, hotThreeAnchorItem, anchorListItem, windowBox },
  data(){
    return {
  		AnchorId:0,
      consumptionList:[],
      mcRankList:[],
      familyRankList:[],
      isWhite:false,
      active:1,
      bFromClient:false,
    }
  },
  beforeCreate(){
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      location.replace('https://wt.sinashow.com/findex.html');
    }
  },
  mounted() {
    //{url}page={page}&qid={qid}&reg_mac={mac}&sign={sign}&token={token}&user_id={uid}&version={version}&time={time}&pid={pid}&uid={uid}
    window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
    if (this.userInfo) {
      this.getHotList(1, 5);
      this.getNewList(1, 2);
      this.getRankList();
    }
  },
  methods:{
    onClickAnchor(uid){
      let strPath = "/live/"+uid;
      let param = { path: strPath };
      this.$router.push(param);
    },
    onClickMoreHot(){
        let param = { path: "/list?type=hot" };
        this.$router.push(param);
    },
    onClickMoreNew(){
        let param = { path: "/list?type=new" };
        this.$router.push(param);
    },
    onPlayEnd(){
      this.AnchorId = 0;
      this.getHotList(1, 2);
    },
    defaultPic(event){
      this.$common.defaultPic(event);
    },
    getSign(user_id, version, time, token, page, reg_mac, key) {
        let t = "{0}{1}{2}{3}{4}{5}{6}";
        return crypt.getMD5(t.format(user_id, version, time, token, page, reg_mac, key));
    },
    getHotList(iPage, iMaxPage){
      let nowtimeStamp = new Date().getTime();
      let sign = this.getSign( this.userInfo.user_id, this.$store.state.loginUserInfo.version, nowtimeStamp, this.userToken, iPage, localStorage.getItem('mac'), 'get_hot_list_h5');
      var data = {
        page:iPage,
        qid: 50000,
        reg_mac: localStorage.getItem('mac'),
        sign:sign,
        token: this.userToken,
        user_id: this.userInfo.user_id,
        ver: this.$store.state.loginUserInfo.version,
        time: nowtimeStamp,        
        pid: this.$store.state.loginUserInfo.pid,
        uid: this.userInfo.user_id,
        version: this.$store.state.loginUserInfo.version,
        source:'live',
        type:'0'
      };
      let that = this;
      this.axios({
        url:"https://external.fengbolive.com/cgi-bin/get_hot_list_h5.fcgi?" + this.$common.changeobj(data),
        adapter: jsonpAdapter,
        callbackParamName: 'jsoncallback', // optional, 'callback' by default
      }).then(res=>{
        let data = res.data;
        if (data.code >= 0 || data.ret >= 0) {
          if (iPage == 1) {
            that.$store.commit('HOTLISTDATA_UPDATE_ANCHORLIST',null);
            if (data.info && data.info.length > 0) {
              that.AnchorId = data.info[0].id;
              localStorage.setItem('AnchorId','' + data.info[0].id);
              localStorage.setItem('FamilyId','' + data.info[0].familyid);
            }
          }
          if (res.data.info) {
            data['page'] = iPage;
            that.$store.dispatch('upDataHotListData',res.data);
            that.$store.dispatch('upDataHotListPage',iPage);
            if (iPage < iMaxPage ) {
              that.getHotList(iPage + 1, iMaxPage);
            }
          }

        }
      }).catch();
    },
    getNewList(iPage, iMaxPage){
      let nowtimeStamp = new Date().getTime();
      let sign = this.getSign( this.userInfo.user_id, this.$store.state.loginUserInfo.version, nowtimeStamp, this.userToken, iPage, localStorage.getItem('mac'), ' sbj09th21sj63kj58ry37');
      var data = {
        page:iPage,
        qid: 50000,
        reg_mac: localStorage.getItem('mac'),
        sign:sign,
        token: this.userToken,
        user_id: this.userInfo.user_id,
        ver: this.$store.state.loginUserInfo.version,
        time: nowtimeStamp,
        pid: this.$store.state.loginUserInfo.pid,
        uid: this.userInfo.user_id,
        version: this.$store.state.loginUserInfo.version,
        source:'live',
        type:'0'
      };
      let that = this;
      this.axios.jsonp("https://external.fengbolive.com/cgi-bin/get_new_anchor_list.fcgi?"+this.$common.changeobj(data)).then(res=>{
			  let data = res;
        if (data.code >= 0 || data.ret >= 0) {
          if (iPage == 1) {
            that.$store.commit('ANCHORLISTDATA_UPDATE_ANCHORLIST', null);
          }
          if (data.info) {
            data['page'] = iPage
            that.$store.dispatch('upDataAnchorListData',data);
            if (iPage < iMaxPage && data.info.length >= 24) {
              that.getNewList(iPage + 1, iMaxPage);
            }
          }
        }
		  })
    },
    getRankList(){
      this.consumptionList=[];
      this.mcRankList=[];
      this.familyRankList=[];
      this.axios({
        url:location.protocol+"//app.fengbolive.com/frontend/web/index.php?r=ismine/iswhiteuser&user_id=" + this.userInfo.user_id,
        adapter: jsonpAdapter
      }).then(res=>{
        res=res.data;
        this.isWhite=res.ret;
      })
      this.getXfList('//live.fengbolive.com/list/consumption/extreme_',1);
      this.getMcList('//live.fengbolive.com/list/consumption/consumption_',1);
      let that = this;
      this.axios({
        url:location.protocol+'//live.fengbolive.com/list/consumption/family_accept.json',
        method:'get'
      }).then(res=>{
        that.familyRankList=res.data.info;
      })
    },
    getXfList(url,page){
      let that = this;
      page=page||1;
      this.axios({
        url:location.protocol+url+page+'.json',
        type:'get'
      }).then(res=>{
        res=res.data;
        if(res.code==1){
          that.consumptionList=that.consumptionList.concat(res.info);
          if(res.info.length<10||page==5){
            return
          }else{
            that.getXfList(url,page+1);
          }
        }
      })
    },
    getMcList(url,page){
      let that = this;
      page=page||1;
      this.axios({
        url:location.protocol+url+page+'.json',
        type:'get'
      }).then(res=>{
        res=res.data;
        if(res.code==1){
          that.mcRankList=that.mcRankList.concat(res.info);
          if(res.info.length<10||page==5){
            return
          }else{
            page++;
            that.getMcList(url,page);
          }
        }
      })
    },
    rankTab(index){
      this.active=index;
    }
  },
  computed:{
    hotListData(){
      return this.$store.state.hotListData.anchorList;
    },
    anchorList(){
      return this.$store.state.anchorListData.anchorList;
    },
    previewAnchorId(){
      return this.AnchorId;
    },
    userInfo(){
      if(this.$store.state.loginUserInfo.info){
          return this.$store.state.loginUserInfo.info
      }else{
          return JSON.parse(sessionStorage.getItem('userInfo'));
      }
    },
    userToken(){
            if(this.$store.state.loginUserInfo.token){
          return this.$store.state.loginUserInfo.token
      }else{
          return sessionStorage.getItem('token');
      }
    },
    noAnchorString(){
      return '主播马上就位，先看看其他主播吧~';
    }
  },
  watch:{
    userInfo(){
      this.getHotList(1, 5);
      this.getNewList(1, 2);
      this.getRankList();
    }
  }
};
</script>
<style>
.left-container{
  display:flex;
  width:100%;
  flex: 0 0 auto;
  height: 428px;
  overflow: hidden;
}
.main {
  min-width: 1200px;
  max-width: 1330px;
  margin: 10px auto 0px auto;
  padding: 0px 50px 0px 50px;
  height: 611px;
}
/*首页直播*/
.liveMain {
  height: 611px;
  display: flex;
}
.liveMain .liveCon {
  width: 388px;
  height: 428px;
  float: left;
}
.liveMain .liveList {
  width: 204px;
  float: right;
}
.liveMain .liveList li {
  width: 134px;
  height: 134px;
  margin-top: 5px;
  position: relative;
  overflow: hidden;
}
.liveMain .liveList li:nth-child(1) {
  margin-top: 0;
}
.liveMain .liveList li.active::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  border: 2px solid #7c46e8;
  z-index: 2;
}
.liveMain .liveList li .maskBox {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 30px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  width: 100%;
  line-height: 30px;
  box-sizing: border-box;
  padding-left: 12px;
  font-size: 14px;
}

.mousecursor  {
  cursor :pointer;
}
/*下部内容*/
.mainCon {
  margin-top: 48px;
}
.mainConL {
  float: left;
}
.mainBanner {
  width: 750px;
  height: 240px;
  margin-bottom: 5px;
}
.bannerPicBox {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.mainListTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}
.mainListTitleCon {
  display: flex;
  justify-content: flex-start;
  font-size: 18px;
  align-items: center;
  color: #333;
}
.mainListTitleIcon {
  background: url("~@/assets/images/new_icon.png");
  background-size: 22px 22px;
  width: 22px;
  height: 22px;
  margin-right: 10px;
}
.mainListTitleMore {
  cursor: pointer;
  font-size: 12px;
  color: #999;
  margin-right: 20px;
}

.liverListConHot {
  height: 428px;
}

.liverListConHot li {
  width: 134px;
  height: 134px;
  border-radius: 5px;
  position: relative;
  float: left;
  overflow: hidden;
  margin-left: 14px;
  margin-bottom: 10px;
}

/*排行榜*/
.rankTitleR {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 14px;
  margin-bottom: 4px;
}
.rankTitleCon {
  display: flex;
  justify-content: flex-start;
  font-size: 18px;
  align-items: center;
  color: #333;
  font-weight:bold;
}
.rankTitleIcon {
  background: url("~@/assets/images/rankIcon.png");
  width: 22px;
  height: 22px;
  margin-right: 10px;
}
.mainConR {
  width: 286px;
  background: #fff;
  float: right; 
  margin-left: 0px; 
}
.rankNav {
  height: 50px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e2e5;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}
.rankNav div {
  border-bottom: 2px solid transparent;
  line-height: 1.8;
}
.rankNav div.active {
  color: #7c46e8;
  border-bottom: 2px solid #7c46e8;
}
.rankMain {
  position: relative;
  height: 530px;
  overflow:hidden;
}
.rankMain ul {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow-y: auto;
}
.rankMain li {
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 0 13px;
  align-items: center;
  height: 53px;
}
.rankMain li:nth-child(2n) {
  background: #f7f7f7;
}
.rankMain li.no1 {
  background-image: linear-gradient(
    -120deg,
    rgb(183, 33, 255) 1%,
    rgb(252, 96, 222) 82%
  );
  background-image: -moz-linear-gradient(
    -120deg,
    rgb(183, 33, 255) 1%,
    rgb(252, 96, 222) 82%
  );
  background-image: -webkit-linear-gradient(
    -120deg,
    rgb(183, 33, 255) 1%,
    rgb(252, 96, 222) 82%
  );
  background-image: -ms-linear-gradient(
    -120deg,
    rgb(183, 33, 255) 1%,
    rgb(252, 96, 222) 82%
  );
  box-shadow: 0px 3px 5px 0px rgba(183, 33, 255, 0.41);
}
.rankMain li .rankIndex {
  width: 30px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #7c46e8;
  font-size: 18px;
  flex:none;
}
.rankMain li .rankIndex .rank-1 {
  background: url("~@/assets/images/icon.png") no-repeat;
  width: 30px;
  height: 100%;
}
.rankMain li .rankIndex .rank-2 {
  background: url("~@/assets/images/icon.png") no-repeat -30px 0;
  width: 30px;
  height: 100%;
}
.rankMain li .rankIndex .rank-3 {
  background: url("~@/assets/images/icon.png") no-repeat -60px 0;
  width: 30px;
  height: 100%;
}

.rankMain .rankPeoPic{
  margin-left: 2px;
  position: relative;
  width: 48px;
  height: 48px;
  flex:none;
}

.rankMain .rankPeoPicBox {
  position:absolute;
  top: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  margin-left: 8px;
  margin-top:7px;
}

.rankMain .rankPeoPicBoxBkg {
  position:absolute;
  background: url("~@/assets/images/ranknum1.png") no-repeat;
  background-size: 48px 48px;
  background-position-y:0px;
  left:2px;
  width: 48px;
  height: 48px;
  z-index: 10;
}

.rankMain .rankPeoInfo {
  flex: 1 1 auto;
  margin-left: 10px;
}
.rankMain .rankPeoInfo .rankPeoName {
  font-size: 12px;
  text-overflow:ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #333;
  width:100%;
  max-width: 90px;
}
.rankMain .rankPeoInfo .rankPeoId {
  font-size: 12px;
  text-overflow:ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #999;
}
.rankMain .rankNum {
  font-size: 12px;
  color: #7c46e8;
  text-transform: uppercase;
  flex:1 1 auto;
  text-align: right;
}
.rankMain li.no1 .rankPeoInfo,
.rankMain li.no1 .rankPeoInfo .rankPeoName,
.rankMain li.no1 .rankNum,
.rankMain li.no1 .rankPeoInfo .rankPeoId {
  color: #fff;
}

.liverList {
  width: 100%;
  overflow: hidden;
}

.liverListCon {
  height: 235px;
}
.liverListCon li {
  width: 134px;
  height: 134px;
  border-radius: 5px;
  position: relative;
  float: left;
  overflow: hidden;
  margin-left: 10px;
  margin-top: 5px;
}
.liverListCon li:nth-child(1) {
  margin-left: 0px;
}

</style>
<style scoped>

.noAnchorFrameHot{
  margin: 130px auto 130px auto;
  text-align:center;
  color: #999999;
}
.noAnchorIconHot{
  margin: 0px auto 37px auto;
  background: url(~@/assets/images/noAnchorbkg.png);
  height: 111px;
  width: 119px;
}


.noAnchorFrameNew{
  text-align:center;
  color: #999999;
  height: 100%;
  display: flex;
  width: 100%;
   justify-content:center;
}
.noAnchorFrameNew span{
  line-height: 75px;
  margin-left: 15px;
  font-size: 14px;
}
.noAnchorIconNew{
  background: url(~@/assets/images/noAnchorbkg.png) no-repeat;
  filter:"progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod='scale')";
  background-size: 100% 100%;
  width: 84px;
  height: 79px;
}
</style>

